/* eslint-disable react/no-danger */
import React from "react";
import { string } from "prop-types";
import classNames from "classnames/bind";
import * as styles from "./CopyBlock.module.scss";

const cx = classNames.bind(styles);

const SEOCopyBlock = ({ contentString }) => (
	<div className={cx("copyblock")} dangerouslySetInnerHTML={{ __html: contentString }} />
);

SEOCopyBlock.propTypes = {
	contentString: string,
};
SEOCopyBlock.defaultProps = {
	contentString: null,
};

export default SEOCopyBlock;
export { SEOCopyBlock };
